export default {
  module: "Module",
  addModule: "AddModule",
  editModule: "EditModule",
};
